import * as React from 'react';
import { useAppointmentContext } from '../context/AppointmentContext.js';
import { useRoutingContext } from '../context/RoutingContext/context.js';
import useBookAppointmentType from './api/use-book-appointment-type.js';
import useVirtualAppointment from './use-virtual-appointment.js';
import { fromArrayToString } from '../../../utils/from-array-to-string.js';

const useBookAppointmentTypeWithUrlParam = ()=>{
    const [, { queryParams  }] = useRoutingContext();
    const [getBookAppointmentType, { error , loading , called , data  }] = useBookAppointmentType();
    const [{ setType  }, { type: typeFromContext  }] = useAppointmentContext();
    const [{ getAppointmentTypeData  }, { typeId: virtualTypeId  }] = useVirtualAppointment();
    React.useEffect(()=>{
        if (error) {
            console.error(error);
            return;
        }
        const typeIdFromUrl = fromArrayToString(queryParams.typeId);
        if (loading || !typeIdFromUrl || typeIdFromUrl === (typeFromContext === null || typeFromContext === void 0 ? void 0 : typeFromContext.id)) {
            return;
        }
        const isVirtualAppointmentTypeId = typeIdFromUrl === virtualTypeId;
        if (isVirtualAppointmentTypeId) {
            setType(getAppointmentTypeData());
            return;
        }
        getBookAppointmentType(typeIdFromUrl);
    }, [
        queryParams.typeId,
        typeFromContext,
        loading,
        error,
        virtualTypeId,
        setType,
        getAppointmentTypeData,
        getBookAppointmentType, 
    ]);
    React.useEffect(()=>{
        const typeIdFromAppointmentTypeInContext = typeFromContext === null || typeFromContext === void 0 ? void 0 : typeFromContext.id;
        const typeIdFromUrl = queryParams.typeId;
        if (!called || !data || loading || !typeIdFromUrl || typeIdFromUrl !== data.id || typeIdFromAppointmentTypeInContext === typeIdFromUrl // we already have the correct appointmentType in context
        ) {
            return;
        }
        setType(data);
    }, [
        called,
        data,
        loading,
        setType,
        typeFromContext === null || typeFromContext === void 0 ? void 0 : typeFromContext.id,
        queryParams.typeId
    ]);
};
var useBookAppointmentTypeWithUrlParam$1 = useBookAppointmentTypeWithUrlParam;

export { useBookAppointmentTypeWithUrlParam$1 as default };
//# sourceMappingURL=use-book-appointment-type-with-url-param.js.map
